import { useRef, useState, useCallback, useEffect } from "react";

// Reproductor de preview de UN solo audio a la vez (muestras de voz). Antes cada botón de
// "Escuchar muestra" hacía new Audio(src).play() sin guardar ninguna referencia: un segundo
// clic (sobre la misma voz u otra) creaba una instancia nueva que sonaba SOLAPADA con la
// anterior en vez de sustituirla. Mismo patrón que ya usan playTrack (TabComposicion.jsx) y
// playSeg (OneClickProducer.jsx), extraído aquí porque se repetía igual en 4 sitios distintos
// (ChannelConfigPage, ChannelWizard, TabNarracion, OneClickModal).
export function useAudioPreview() {
  const audioRef = useRef(null);
  const [playingId, setPlayingId] = useState(null);

  const stop = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      audioRef.current = null;
    }
    setPlayingId(null);
  }, []);

  const toggle = useCallback((id, src) => {
    if (playingId === id) { stop(); return; }
    stop();
    const a = new Audio(src);
    a.onended = stop;
    a.play().then(() => setPlayingId(id)).catch(stop);
    audioRef.current = a;
  }, [playingId, stop]);

  // Si el componente se desmonta (se cierra el modal) mientras suena una muestra, que no
  // se quede sonando de fondo.
  useEffect(() => () => { audioRef.current?.pause(); }, []);

  return { playingId, toggle };
}
